import * as React from 'react';
import {PureComponent} from 'react';
import {mapControlStyle} from "./mapControlStyle";

export default class HomeIcon extends PureComponent <any, any> {
    render() {
        return (
            <svg viewBox="0 0 200 200" style={{...mapControlStyle}}>
                <path className="st0" d="M44.2,75.3"/>
                <polyline className="st0" points="148.2,81.3 148.2,149.3 44.2,149.3 44.2,81.3"/>
                <line className="st0" x1="96.2" y1="31.3" x2="148.2" y2="82.5"/>
                <line className="st0" x1="96.2" y1="31.3" x2="44.2" y2="82.5"/>
                <rect x="84" y="108.4" className="st0" width="24.6" height="40.9"/>
                <polyline className="st0" points="140.1,75.3 140.1,49.2 122.2,49.2 122.2,56.9"/>
            </svg>
        );
    }
}
